import { can } from "modules/settings/accessRoles";
import React, { useEffect } from "react";
import styled from "styled-components";

import Autocomplete from "@mui/material/Autocomplete"
import { setSnackbar } from "../../snackbar/api/snackbar";
import {
  Checkbox, Box, Typography,
  ButtonGroup, IconButton, Breadcrumbs as MuiBreadcrumbs, Divider as MuiDivider, Paper as MuiPaper, 
  FormControlLabel, MenuItem, TextField as MuiTextField, Button as MuiButton,
  FormControl, InputLabel, Select, 
  CircularProgress as MuiCircularProgress,
} from "@mui/material";

//import OutlinedInput from '@mui/material/OutlinedInput';
import {
  useNavigate} from "react-router-dom";
//Material UI Icons
import _ from "lodash";


//Material UI Components and Functions
import { makeStyles } from '@mui/styles';


import { spacing } from "@mui/system";

import {
  EditableTable, 
  newConditionalOnSelectButton
} from "../../../components/EditableTable";

import SearchIcon from '@mui/icons-material/Search';

// Redux Components
import PropTypes from 'prop-types';
import { connect, useDispatch } from 'react-redux';
import { searchAccountsByFieldAndValue, updateFilters, searchForAccountsByFilters } from '../api/actions';
import { getAllPropertyPreviews } from '../../apl/api/actions';
import { addAccountsSelectedToCheck } from '../../payments/api/actions';
import { deleteAccounts } from "../../account/api/actions";
import StatusTag from "../../apl/components/StatusTag";
const Button = styled(MuiButton)(spacing);

const TextField = styled(MuiTextField)(spacing);
const DashboardToolBarButton = styled(Button)`
padding: 4px;
min-width: 0;
svg {
    width: 2em;
    height: 2em;
}
`;

const CircularProgress = styled(MuiCircularProgress)(spacing);

const useStyles = makeStyles((theme) => ({
  title: {
    flexGrow: 1,
  },
  searchBarGrid: {
    //paddingBottom: "10px",
    fontSize: "90%",
    height: "5%"
  },
  searchDropDownButton: {
    height: "90%"
  },
  percentDif: {
    textAlign: 'right',
    color: 'green'
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  loadingIcon: {
    position: 'absolute', left: '50%', top: '50%',
    transform: 'translate(-50%, -50%)'
  },
  withoutLabel: {
    marginTop: theme.spacing(3),
  },

}));

const Divider = styled(MuiDivider)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

const Spacer = styled.div`
  flex: 1 1 100%;
`;

//Editable Table Object Expects: {objectArray, fieldTitles(Array), fieldTypes(Array), fieldNames(Array), handleRowClickParentMethod}
// Method can take line items if they exist initially or starts as an empty array of nothing passed
function AccountPreviewsTable(props) {
  const dispatch = useDispatch();
  const [accountStatusQueryType, setAccountStatusQueryType] = React.useState(0);

  const classes = useStyles();
  const navigate = useNavigate();

  // Filters
  const [customerType, setCustomerType] = React.useState(null);
  const [accountStatusType, setAccountStatusType] = React.useState("Active");
  const [searchQuery, setSearchQuery] = React.useState(""); // should be all thats needed to reduce the disconnects shown to only that accounts
  const [property, setProperty] = React.useState("");
  const [propertyName, setPropertyName] = React.useState(null);
  const [accountBalanceOwedFilter, setAccountBalanceOwedFilter] = React.useState(false);

  // Table Data management
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [resetCache, setResetCachedData] = React.useState(true);
  const [focus, setFocus] = React.useState(false);
  const [minAccountObj, setMinAccountObj] = React.useState(props.minAccountObj || false);
  const [SearchOnTypeInput, setSearchOnTypeInput] = React.useState(props.SearchOnTypeInput);
  const [currentAccountDPreviews, setCurrentAccountDPreviews] = React.useState([]);
  
  const canDelete = can(props.user.details, "deleteAccounts");

  const handleChangeRowsPerPage = (rowsPerPage) => {
    setPage(0);
    setResetCachedData(false);
    setRowsPerPage(rowsPerPage);
  };

  const handleChangePage = (page) => {
    setResetCachedData(false);
    setPage(page);
  };

  const onAccountStatusTypeSelected = (selection) => {
    setAccountStatusType(selection);
    setResetCachedData(true);
    setPage(0);
  }

  const onCustomerTypeSelected = (selection) => {
    setCustomerType(selection);
    setResetCachedData(true);
    setPage(0);
  }

  const handleSelectedPropertyChange = (event) => {
    setPage(0);
    setResetCachedData(true);
    const value = event.target.value || "";
    if (value === "" || value == null) {
      setPropertyName(null);
      setProperty("");
    }
    else {
      const propertyPreviews = props.apl.data?.propertyPreviews;
      if (propertyPreviews && propertyPreviews.length > 0) {
        var target = propertyPreviews.find(x => x.uuid === value);
        if (target) {
          setPropertyName(target.name);
        }
      }
      setProperty(value);
    }
  };


  // When the textbox changes
  const handleSearchTargetChange = (event) => {
    setSearchQuery(event.target.value);
    if (SearchOnTypeInput) {
      setPage(0);
      setResetCachedData(true);
      getAccountsWithQuery();
    }
  }
  const IsAbleToDeleteAccount = (account) => {
    console.log("account: ", account)
    return account.accountStatusId == 7 ? true : false;
  }

  const HandleDeleteAccount = (accounts)  => {
   
        props.deleteAccounts(accounts)
       .then(()=> {
        if(props.account.error == '' || !props.account.error){
      
           dispatch(setSnackbar(true, "success", `Deleted account.`))
          
          }else {
             dispatch(setSnackbar(true, "error", `Failed to delete account.`))
          }
      })
   
  }

  const getAccountsWithQuery = () => {
    const propertyUuid = property;
    const query = { page, rowsPerPage, customerType, searchQuery, propertyUuid, accountStatusType, resetCache, accountBalanceOwedFilter, minAccountObj };
    props.searchForAccountsByFilters(query);
  };

  const handleSearchTargetButtonClicked = () => {
    setPage(0);
    setResetCachedData(true);
    getAccountsWithQuery();
  }


  useEffect(() => {
    if (props.accountsSearch.data.accountPreviews.items) {
      if (((page + 1) * rowsPerPage > props.accountsSearch.data.accountPreviews.items.length) || resetCache) {
        getAccountsWithQuery();
      }
    }
  }, [page, property, rowsPerPage, customerType, accountStatusType, accountBalanceOwedFilter, minAccountObj]);

  const CurrentLookupTypeButton = () => {
    return (
      <IconButton onClick={handleSearchTargetButtonClicked} style={{ width: "50px", height: "50px" }}>
        <SearchIcon style={{ width: "30px", height: "30px" }} />
      </IconButton>
    );
  }
  const handleTargetAccountBalancesChange = (event) => {
    setAccountBalanceOwedFilter(!accountBalanceOwedFilter);
  }

  // Helper functions to get the appropriate styles based on filter values
  const getAccountStatusChipStyle = (status) => {
    if (accountStatusType === status) {
      switch (status) {
        case "Active":
          return {
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50 !important",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(76, 175, 80, 0.2)",
              border: "1px solid #4caf50",
            }
          };
        case "Inactive":
          return {
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ff9800 !important",
            border: "1px solid #ff9800",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(255, 193, 7, 0.2)",
              border: "1px solid #ff9800",
            }
          };
        case "Inactive D":
          return {
            backgroundColor: "rgba(244, 67, 54, 0.1)",
            color: "#f44336 !important",
            border: "1px solid #f44336",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(244, 67, 54, 0.2)",
              border: "1px solid #f44336",
            }
          };
        case "Transfer":
          return {
            backgroundColor: "rgba(255, 152, 0, 0.1)",
            color: "#ff9800 !important",
            border: "1px solid #ff9800",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(255, 152, 0, 0.2)",
              border: "1px solid #ff9800",
            }
          };
        case null:
          return {
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50 !important",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(76, 175, 80, 0.2)",
              border: "1px solid #4caf50",
            }
          };
        default:
          return {
            backgroundColor: "rgba(158, 158, 158, 0.1)",
            color: "#757575 !important",
            border: "1px solid #bdbdbd",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(158, 158, 158, 0.2)",
              border: "1px solid #bdbdbd",
            }
          };
      }
    }
    return {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575 !important",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(158, 158, 158, 0.2)",
        border: "1px solid #bdbdbd",
      }
    };
  };

  const getCustomerTypeChipStyle = (type) => {
    if (customerType === type) {
      switch (type) {
        case "Tenant":
          return {
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50 !important",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(76, 175, 80, 0.2)",
              border: "1px solid #4caf50",
            }
          };
        case "PM":
          return {
            backgroundColor: "rgba(33, 150, 243, 0.1)",
            color: "#2196f3 !important",
            border: "1px solid #2196f3",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(33, 150, 243, 0.2)",
              border: "1px solid #2196f3",
            }
          };
        case "Common":
          return {
            backgroundColor: "rgba(33, 150, 243, 0.1)",
            color: "#2196f3 !important",
            border: "1px solid #2196f3",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(33, 150, 243, 0.2)",
              border: "1px solid #2196f3",
            }
          };
        case "ManagementCo":
          return {
            backgroundColor: "rgba(156, 39, 176, 0.1)",
            color: "#9c27b0 !important",
            border: "1px solid #9c27b0",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(156, 39, 176, 0.2)",
              border: "1px solid #9c27b0",
            }
          };
        case null:
          return {
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            color: "#4caf50 !important",
            border: "1px solid #4caf50",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(76, 175, 80, 0.2)",
              border: "1px solid #4caf50",
            }
          };
        default:
          return {
            backgroundColor: "rgba(158, 158, 158, 0.1)",
            color: "#757575 !important",
            border: "1px solid #bdbdbd",
            fontWeight: 500,
            borderRadius: "16px",
            fontSize: "0.875rem",
            textTransform: "none",
            "&:hover": {
              backgroundColor: "rgba(158, 158, 158, 0.2)",
              border: "1px solid #bdbdbd",
            }
          };
      }
    }
    return {
      backgroundColor: "rgba(158, 158, 158, 0.1)",
      color: "#757575 !important",
      border: "1px solid #bdbdbd",
      fontWeight: 500,
      borderRadius: "16px",
      fontSize: "0.875rem",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "rgba(158, 158, 158, 0.2)",
        border: "1px solid #bdbdbd",
      }
    };
  };

  const setSearchFocus = () => {
    setFocus(true);
  }
  const unsetSearchFocus = () => {
    setFocus(false);
  }

  const AccountRowStatusStyling = (account) => {
    account.name = account.lastName;
    if (account.firstName != null && account.firstName.trim() != "") {
      account.name = account.firstName + ", " + account.lastName;
    }
    account.accountStatus = <><StatusTag type={"accountStatus"} isLoading={props.accountsSearch.isLoading} typeId={account.accountStatusId} showTitle={false} condensed={true} /></>
    if (props.isBulkCheckEntry) {
      if (account.stopPayment)
        account.accountStatus = <><StatusTag type={"accountStatus"} isLoading={props.accountsSearch.isLoading} typeId={account.accountStatusId} showTitle={false} condensed={true} />
          <StatusTag type={"Alert"} label={"Stopped Payment"} condensed={true} /></>
    }
    else {
      account.customerType = <StatusTag type={"customerType"} isLoading={props.accountsSearch.isLoading} typeId={account.customerTypeId} showTitle={false} condensed={true} />
    }
    return {}; // Returns an empty style as to not effect each row
  };

  // Table Stuff:      
  const fieldTitles = ["Acct #",
    "Status",
    "Type",
    "Name",
    "Address",
    "Balance",
    "Property",
    "Email",
    "Phone #"];

  const fieldTypes = ["label",
    "label",
    "label",
    "label",
    ["labelSmall", "labelSmall"],
    "moneyLabel",
    "label",
    "label",
    "phoneLabel"];

  const fieldNames = ["accountNum",
    "accountStatus",
    "customerType",
    "name",
    ["serviceAddress1", "serviceAddress2"],
    "balance",
    "propertyName",
    "email",
    "phone1"];
  // Must be the exact name of the properties you wanna show


  const bulkCheckFieldTitles = ["Acct #",
    "Status",
    "Property",
    "Name",
    "Address",
    "Balance"];

  const bulkCheckFieldTypes = ["label",
    "label",
    "label",
    "label",
    ["labelSmall", "labelSmall"],
    "moneyLabel",];

  const bulkCheckFieldNames = ["accountNum",
    "accountStatus",
    "propertyName",
    "name",
    ["serviceAddress1", "serviceAddress2"],
    "balance"]; // Must be the exact name of the properties you wanna show



  const onAccountSelected = (item) => {
    window.open("/accountmanager/" + item.accountNum);
  }

  const handleSelectOptionClick = (event, value) => {
    if (value && value.accountNum && value.uuid) {
      navigate("/accountmanager/" + value.accountNum);
      window.location.reload();
    }
  }

  const Filters = () => {
    const classes = useStyles();

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Box sx={{ width: '100%' }}>
          {!props.isAccountPage &&
            <>
              <FormControl fullWidth my={2}>
                <InputLabel id="propertyToBillDropDownLabel">
                  {props.apl.isLoading &&
                    <CircularProgress size={15} m={0} />
                  }
                </InputLabel>
                {property === "" && props.apl.isLoading ?
                  <Select
                    labelId="propertyToBillDropDownLabel"
                    id="propertyToBillDropDown"
                    value={property || ""}
                    className={classes.selectedPropertyLocationLabel}
                    onChange={handleSelectedPropertyChange}
                    fullWidth
                    disabled
                    my={2}>
                  </Select>
                  :
                  <Select
                    labelId="propertyToBillDropDownLabel"
                    id="propertyToBillDropDown"
                    value={property || ""}
                    className={classes.selectedPropertyLocationLabel}
                    onChange={handleSelectedPropertyChange}
                    fullWidth
                    my={2}
                    displayEmpty>
                    {props.apl.data?.propertyPreviews && props.apl.data.propertyPreviews.length > 0 ?
                      [
                        <MenuItem key="all" value={""}>All</MenuItem>,
                        props.apl.data.propertyPreviews.map((item, key) => {
                          return (
                            <MenuItem key={key} value={item.uuid || ""}>{item.name}</MenuItem>
                          )
                        })
                      ]
                      :
                      [
                        <MenuItem key="no-properties" value={""}>No Properties Found</MenuItem>
                      ]
                    }
                  </Select>
                }
              </FormControl>
            </>
          }
        </Box>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#666' }}>
              Account Status
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              <Button
                onClick={() => { onAccountStatusTypeSelected(null) }}
                sx={getAccountStatusChipStyle(null)}
                variant="outlined"
                size="small"
              >
                All
              </Button>
              <Button
                onClick={() => { onAccountStatusTypeSelected("Active") }}
                sx={getAccountStatusChipStyle("Active")}
                variant="outlined"
                size="small"
              >
                Active
              </Button>
              <Button
                onClick={() => { onAccountStatusTypeSelected("Inactive") }}
                sx={getAccountStatusChipStyle("Inactive")}
                variant="outlined"
                size="small"
              >
                Inactive
              </Button>
              <Button
                onClick={() => { onAccountStatusTypeSelected("Inactive D") }}
                sx={getAccountStatusChipStyle("Inactive D")}
                variant="outlined"
                size="small"
              >
                Inactive D
              </Button>
              <Button
                onClick={() => { onAccountStatusTypeSelected("Transfer") }}
                sx={getAccountStatusChipStyle("Transfer")}
                variant="outlined"
                size="small"
              >
                Transfer
              </Button>
            </Box>
          </Box>
          <Box sx={{ flex: 1 }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500, color: '#666' }}>
              Customer Type
            </Typography>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
              <Button
                onClick={() => { onCustomerTypeSelected(null) }}
                sx={getCustomerTypeChipStyle(null)}
                variant="outlined"
                size="small"
              >
                All
              </Button>
              <Button
                onClick={() => { onCustomerTypeSelected("PM") }}
                sx={getCustomerTypeChipStyle("PM")}
                variant="outlined"
                size="small"
              >
                PM
              </Button>
              <Button
                onClick={() => { onCustomerTypeSelected("Tenant") }}
                sx={getCustomerTypeChipStyle("Tenant")}
                variant="outlined"
                size="small"
              >
                Tenant
              </Button>
              <Button
                onClick={() => { onCustomerTypeSelected("Common") }}
                sx={getCustomerTypeChipStyle("Common")}
                variant="outlined"
                size="small"
              >
                Common
              </Button>
            </Box>
          </Box>
        </Box>
        <Box>
          <FormControlLabel control={<Checkbox
            checked={accountBalanceOwedFilter}
            onClick={handleTargetAccountBalancesChange}
            inputProps={{ "aria-labelledby": "Owed Balance" }}
          />} label="With Owed Balance" />
        </Box>
      </Box>
    );
  };
  const addAccountsSelectedToCheck = (items) => {
    for (var x = 0; x < items.length; x++) {
      items[x].amountCovered = 0;
      if (items[x].balance > 0) {
        items[x].amountCovered = items[x].balance;
      }
    }
    props.addAccountsSelectedToCheck(items);
  };


  const ConditionalOnSelectButtons = [
    newConditionalOnSelectButton("Add Accounts To Check", () => { return (true) }, addAccountsSelectedToCheck)
  ];

  if (props.isAccountSearchBar && props.isAccountSearchBar == true) {
    return (
      <>
        <div className={classes.search}>
          <Autocomplete
            id="combo-box"
            options={props.accountsSearch.data.accountPreviews.items || []}
            getOptionLabel={(option) => {
              if (option && option.lastName) {
                let name = "";
                if (option.firstName && option.firstName != null) {
                  name = option.firstName;
                }
                if (option.lastName && option.lastName != null) {
                  name = name + " " + option.lastName;
                }
                return option.accountNum + " : " + name
              }
            }}
            onChange={handleSelectOptionClick}
            renderInput={(params) => (
              <TextField
                label="Accounts Search"
                {...params}
                onChange={handleSearchTargetChange}
                value={searchQuery}
                size={"small"}
                variant={"outlined"}
                InputLabelProps={{
                  shrink: true,
                }}
                fullWidth
                my={2}
              />
            )}
          />
        </div>
      </>
    )
  }


  return (
    <div style={{ width: '100%', margin: 0, padding: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box sx={{ width: '100%' }}>
            {/* <AccountSearchBar onChange={handleSearchTargetChange}/> */}
            <TextField
            id={"searchTarget"}
            label="Search For Accounts"
            type={"text"}
            autoFocus={focus}
            onChange={handleSearchTargetChange}
            name={"searchTarget"}
            defaultValue={searchQuery}
            onClick={setSearchFocus}
            fullWidth
            autoComplete={"off"}
            my={2}
            size={"small"}
            variant={"outlined"}
            InputLabelProps={{
              shrink: true,
            }}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                // Do code here
                ev.preventDefault();
                setPage(0);
                setResetCachedData(true);
                getAccountsWithQuery();
              }
            }}
            InputProps={{ endAdornment: <CurrentLookupTypeButton /> }}
            helperText="Currently searching by account characteristics. Use Comma to seperate search values"
          >
          </TextField>
          </Box>
        </Box>
        
        {/* Filters section - moved outside of EditableTable modal */}
        <Box sx={{ mb: 3, p: 2, border: '1px solid #e0e0e0', borderRadius: 1, backgroundColor: '#f9f9f9' }}>
          <Filters />
        </Box>
        
        {(props.isBulkCheckEntry && props.isBulkCheckEntry == true) ?
          <EditableTable
            readOnly={false}
            canAddItems={false}
            canSave={false}
            canDelete={false}
            isLoading={props.accountsSearch.isLoading}
            conditionalStylingMethod={AccountRowStatusStyling}
            currentActiveFilters={[customerType, accountStatusType, propertyName, accountBalanceOwedFilter ? "Account Balance Owed" : null]}
            // Functional methods of table
            handleRowClickParentMethod={onAccountSelected}
            // Properties of table  

            objectArray={props.accountsSearch.data.accountPreviews}
            fieldTitles={bulkCheckFieldTitles}
            fieldTypes={bulkCheckFieldTypes}
            fieldNames={bulkCheckFieldNames}
            customChangePageRowsEvent={handleChangeRowsPerPage}
            customHandleChangePageEvent={handleChangePage}
            defaultItemCount={rowsPerPage}
            conditionalOnSelectButtons={ConditionalOnSelectButtons}
            totalRowCount={props.accountsSearch.data.previewsSummary == null ? 0 : props.accountsSearch.data.previewsSummary.totalRows}
          />
          :
          <EditableTable
            readOnly={false}
            canAddItems={false}
            canSave={false}
            canDelete={canDelete}
            verifyDelete={true}
            manualItemDeletionMethod={HandleDeleteAccount}
            isLoading={props.accountsSearch.isLoading}
            conditionalStylingMethod={AccountRowStatusStyling}
            currentActiveFilters={[customerType, accountStatusType, propertyName, accountBalanceOwedFilter ? "Account Balance Owed" : null]}
            // Functional methods of table
            handleRowClickParentMethod={onAccountSelected}
            // Properties of table  
            objectArray={props.accountsSearch.data.accountPreviews}
            fieldTitles={fieldTitles}
            fieldTypes={fieldTypes}
            fieldNames={fieldNames}
            customChangePageRowsEvent={handleChangeRowsPerPage}
            customHandleChangePageEvent={handleChangePage}
            defaultItemCount={rowsPerPage}
            customOnDeleteValidationMethod={IsAbleToDeleteAccount}
            totalRowCount={props.accountsSearch.data.previewsSummary == null ? 0 : props.accountsSearch.data.previewsSummary.totalRows}
          />
        }
    </div>
  );
}
// Component Properties
AccountPreviewsTable.propTypes = {
  // Store objects:
  user: PropTypes.object.isRequired,
  apl: PropTypes.object.isRequired,
  billing: PropTypes.object.isRequired,
  accountsSearch: PropTypes.object.isRequired,
  searchAccountsByFieldAndValue: PropTypes.func.isRequired,
  getAllPropertyPreviews: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  searchForAccountsByFilters: PropTypes.func.isRequired,
  deleteAccounts: PropTypes.func.isRequired,
}

// Component State
function AccountPreviewsTableState(state) {
  return {
    user: state.user,
    apl: state.apl,
    billing: state.billing,
    accountsSearch: state.accountsSearch,
    account: state.account
  }
}
export default connect(AccountPreviewsTableState, { searchAccountsByFieldAndValue, getAllPropertyPreviews, updateFilters, searchForAccountsByFilters, addAccountsSelectedToCheck, deleteAccounts})(AccountPreviewsTable)


